import React from "react";

import { useFormikContext } from "formik";

import { useGetSurvey, useCreateSurvey } from "manager/hooks/api";
import { useBgccEntitlement } from "manager/hooks/api/useBgccEntitlement";
import { DealSetup } from "manager/interfaces/api";
import { CONTENT_TYPE } from "shared/config/constants";
import { usePermissions } from "shared/hooks";
import { SurveyType } from "shared/interfaces/api";

import { verificationOfResidency } from "./constants";
import ScreeningForApplicantsAndOccupants from "./ScreeningForApplicantsAndOccupants";

interface ScreeningForApplicantsAndOccupantsContainerProps {
  loading?: boolean;
  disabled?: boolean;
  dealSetup: DealSetup;
  forSettingsLabel: string;
  isVeroGoActive?: boolean;
}

const ScreeningForApplicantsAndOccupantsContainer = ({
  loading,
  disabled,
  dealSetup,
  forSettingsLabel,
  isVeroGoActive,
}: ScreeningForApplicantsAndOccupantsContainerProps) => {
  const { values } = useFormikContext();

  const {
    isArgyleEnabled,
    isPersonaEnabled,
    isVerificationOfResidencyEnabled,
    isConditionallyProceedEnabled,
  } = usePermissions();

  const { data: bgccEntitlement, isLoading: isBgccEntitlementLoading } =
    useBgccEntitlement();
  const isBgccEnabled = bgccEntitlement?.bgccEnabled ?? true;

  const { survey, isSurveyLoading } = useGetSurvey(
    {
      dealSetupId: dealSetup?.id,
      surveyType: SurveyType.VOR,
    },
    {
      enabled:
        isVerificationOfResidencyEnabled && values[verificationOfResidency],
    }
  );
  const { createSurvey } = useCreateSurvey();

  const toggleVor = (checked: boolean, setFieldValue: Function) => {
    if (checked && !survey) {
      createSurvey(
        {
          objectId: dealSetup?.id,
          contentType: CONTENT_TYPE.dealSetup,
          surveyType: SurveyType.VOR,
          surveyQuestions: [],
        },
        {
          onSuccess: () => {
            setFieldValue(verificationOfResidency, checked);
          },
        }
      );
    } else {
      setFieldValue(verificationOfResidency, checked);
    }
  };

  return (
    <ScreeningForApplicantsAndOccupants
      isArgyleEnabled={isArgyleEnabled}
      isPersonaEnabled={isPersonaEnabled}
      isVerificationOfResidencyEnabled={isVerificationOfResidencyEnabled}
      isConditionallyProceedEnabled={isConditionallyProceedEnabled}
      isSurveyLoading={isSurveyLoading}
      forSettingsLabel={forSettingsLabel}
      loading={loading || isBgccEntitlementLoading}
      disabled={disabled}
      isBgccEnabled={isBgccEnabled}
      vorSurvey={survey}
      toggleVor={toggleVor}
      isVeroGoActive={isVeroGoActive}
      isV1ExpressionEngine={Boolean(dealSetup?.isV1ExpressionEngine)}
    />
  );
};

export default ScreeningForApplicantsAndOccupantsContainer;
